angular.module 'zc.master.campaigns'

.factory "DataScriptCampaignResults", ($q, FacadeV2) ->

  class DataScriptCampaignResults

    constructor: (@dimension) ->

    find: (params) ->
      d = $q.defer()
      FacadeV2.request "/master/data_script_campaign_results/daily",
        "params": params
      .then (res) =>
        if res.status != 200
          return reject "failed"
        d.resolve res.data
      d.promise



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.campaigns/data_script_campaign_results.service.coffee